import React from 'react'
import styles from './FooterDetails.module.css'

const CorporateTraining = () => {
 return (
  <div className={styles.FooterDetails}>
   <img src='/images/CorporateTraining.jpeg' alt='about-us' width='100%' />
   <h1 className={styles.title}>Corporate Training</h1>
   <h3 className={styles.heading}>Welcome to Smartranx Education Center </h3>
   <p className={styles.body}>
    At Smartranx Education Center, we are dedicated to enhancing the skills and
    capabilities of your workforce through our comprehensive corporate training
    programs. Our mission is to deliver customized training solutions that drive
    your organization’s success by empowering your employees with the knowledge
    and skills they need to excel.
   </p>
   <h3 className={styles.heading}>Our Focus</h3>
   <p className={styles.body}>
    Our corporate training programs are designed to cater to the unique needs of
    businesses across various industries. We specialize in professional
    development courses, including PMP, ITIL, CSM, and other industry-relevant
    certifications. Our goal is to equip your team with the latest skills and
    best practices to help your organization stay competitive and achieve its
    strategic objectives.
   </p>
   <h3 className={styles.heading}>Why Choose Smartranx Education Center?</h3>
   <p className={styles.body}>
    What makes Smartranx Education Center the ideal choice for your corporate
    training needs? Here’s what sets us apart:
   </p>
   <ol>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>Experienced Trainers:</span> Our
      trainers are seasoned professionals with over 25 years of industry
      experience, bringing practical insights and real-world expertise to our
      training programs.
     </p>
    </li>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>Tailored Training Solutions:</span> We
      understand that every organization is unique. That’s why we offer
      customized training solutions designed to meet your specific business
      needs and goals.
     </p>
    </li>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>High Success Rate:</span> Our training
      programs have a proven success rate of 98.6%, ensuring that your employees
      gain the knowledge and skills necessary to excel in their roles.
     </p>
    </li>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>Flexible Delivery Options:</span> We
      offer a range of delivery options, including in-person training, virtual
      classrooms, and blended learning, providing you with the flexibility to
      choose the format that works best for your team.
     </p>
    </li>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>Comprehensive Support:</span> From
      initial consultation to post-training support, our team is dedicated to
      ensuring a seamless and effective training experience for your
      organization.
     </p>
    </li>
   </ol>
   <h3 className={styles.heading}>Key Benefits</h3>
   <ol>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>Enhanced Employee Performance:</span>{' '}
      Our training programs are designed to improve the performance and
      productivity of your employees, helping them to apply new skills and
      knowledge directly to their roles.
     </p>
    </li>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>Increased Employee Retention:</span>{' '}
      Investing in professional development demonstrates your commitment to your
      employees’ growth, leading to higher job satisfaction and retention rates.
     </p>
    </li>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>Competitive Advantage:</span> By
      equipping your team with the latest industry knowledge and skills, your
      organization can stay ahead of the competition and adapt to changing
      market demands.
     </p>
    </li>
    <li>
     <p className={styles.body}>
      <span className={styles.subHeading}>Customized Learning Experience:</span>{' '}
      Our tailored training programs ensure that the content is relevant and
      applicable to your specific business needs, maximizing the impact of the
      training.
     </p>
    </li>
   </ol>
   <h3 className={styles.heading}>Our Achievements</h3>
   <p className={styles.body}>
    Smartranx Education Center takes pride in its track record of delivering
    high-quality corporate training programs. Our 100% customer satisfaction
    rate and 98.6% pass rate are testaments to our commitment to excellence and
    our ability to deliver results that matter.
   </p>
   <h3 className={styles.heading}>Get Started</h3>
   <p className={styles.body}>
    Partner with Smartranx Education Center to transform your workforce and
    drive organizational success. Contact us today to learn more about our
    corporate training offerings and how we can tailor a solution to meet your
    needs.
   </p>
  </div>
 )
}

export default CorporateTraining
